
import { Options, Vue } from "vue-class-component";
import KanbanOrcamento from "../../components/orcamento/KanbanOrcamento.vue";

@Options({
  props: {
    isNew: Boolean,
    idOrcamento: Number
  },
  components: {
    KanbanOrcamento
  }
})
export default class Orcamento extends Vue {
  isNew?: boolean;
  idOrcamento?: number;
}
